import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mein Scheitel hat zwei Jahre lang gleich ausgesehen. In Woche sechs bemerkte ich, dass er sich langsam wieder füllt.',
    author: 'Lena K.',
    detail: 'verifizierte Käuferin – 3-Flaschen-Ritual'
  }, {
    quote: 'Ich hab alles versucht – Nahrungsergänzung, Rosmarin, ein Dermaroller, sogar vier Monate Minoxidil. Das hier ist das erste Produkt, das ich tatsächlich über Woche drei hinaus weiterverwendet hab. Meine Bürste sammelt vielleicht noch ein Drittel der Haare von früher.',
    author: 'Tara M.',
    detail: 'verifizierte Käuferin – 3-Flaschen-Ritual'
  }, {
    quote: 'Mein postpartaler Haarausfall begann in Monat drei. Ich geriet in Panik. Luisé hat ihn nicht über Nacht verschwinden lassen – aber nach einem Monat sah der Duschablauf fast normal aus. Ich fühlte mich wieder in der Lage zu handeln.',
    author: 'Julia W.',
    detail: 'verifizierte Käuferin – 2-Flaschen-Test'
  }];
  return <section className="py-16 md:py-24 bg-cream" data-id="element-203">
      <div className="max-w-editorial mx-auto px-4" data-id="element-204">
        <h2 className="text-3xl font-heading font-semibold text-center text-charcoal mb-12" data-id="element-205">
          Was Frauen sagen, die drangeblieben sind
        </h2>

        <div className="space-y-8" data-id="element-206">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 md:p-8 rounded-lg shadow-sm border border-charcoal/5" data-id="element-207">
              <div className="flex text-accent mb-4" data-id="element-208">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-209">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-210" />
                  </svg>)}
              </div>
              <blockquote className="text-lg font-body italic text-charcoal/90 mb-4" data-id="element-211">
                „{t.quote}"
              </blockquote>
              <div className="font-ui text-sm" data-id="element-212">
                <span className="font-semibold text-charcoal" data-id="element-213">{t.author}</span>
                <span className="text-charcoal/60 ml-2" data-id="element-214">{t.detail}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}